module.exports = __webpack_public_path__ + "static/media/calendar-mood.fbfbba99.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/calendar-mood.png
// module id = 474
// module chunks = 0